export enum DashboardSections {
  Temperature = "temperature",
  Mechanical = "mechanical",
  Electrical = "electrical"
}